// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faqs_O8Dim .accordion_O-RrU+.accordion_O-RrU{margin-top:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faqs": "faqs_O8Dim",
	"accordion": "accordion_O-RrU"
};
module.exports = ___CSS_LOADER_EXPORT___;
